module.exports = [{
      plugin: require('/zeit/4cd8a442/node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[],"extensions":[".md",".mdx"],"remarkPlugins":[null,[null,{"type":"yaml","marker":"-"}],null],"rehypePlugins":[null,null,null],"gatsbyRemarkPlugins":[],"defaultLayouts":{"default":"/zeit/4cd8a442/node_modules/gatsby-theme-docz/src/base/Layout.js"}},
    },{
      plugin: require('/zeit/4cd8a442/node_modules/gatsby-theme-docz/gatsby-browser.js'),
      options: {"plugins":[],"hastPlugins":[null],"mode":"dark","mdPlugins":[null]},
    }]
